/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
let e=class{constructor(e={},s={},t=8,i=1/0){this.disabledExtensions=e,this.debugWebGLExtensions=s,this.maxAnisotropy=t,this.maxPreferredTexturePixels=i}};export{e as RenderingContextOptions};
